import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIcon2CarsSg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={16}
    fill="none"
    viewBox="0 0 20 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-2cars-sg_svg__a)"
      d="m1.125 4.219.813-2.5C2.28.719 3.25 0 4.313 0h4.343c1.063 0 2.031.719 2.375 1.719L11.781 4h-.469A3.49 3.49 0 0 0 8 6.406l-.719 2.125c-.187.156-.375.313-.531.469H2.5v1c0 .563-.469 1-1 1H1c-.563 0-1-.438-1-1V6c0-.781.438-1.469 1.125-1.781ZM3.281 4h6.406l-.562-1.656A.508.508 0 0 0 8.656 2H4.312a.508.508 0 0 0-.468.344L3.28 4ZM2.5 5.75a.74.74 0 0 0-.75.75c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75ZM11.313 5h4.343c1.063 0 2.031.688 2.375 1.719l.813 2.5C19.53 9.53 20 10.219 20 11v4c0 .563-.469 1-1 1h-.5c-.563 0-1-.438-1-1v-1h-8v1c0 .563-.469 1-1 1H8c-.563 0-1-.438-1-1v-4c0-.781.438-1.469 1.125-1.781l.813-2.5A2.515 2.515 0 0 1 11.312 5Zm0 2a.508.508 0 0 0-.47.344L10.282 9h6.406l-.562-1.656A.508.508 0 0 0 15.656 7h-4.344ZM9.5 12.25a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75.74.74 0 0 0-.75.75c0 .438.313.75.75.75Zm8-1.5a.74.74 0 0 0-.75.75c0 .438.313.75.75.75a.74.74 0 0 0 .75-.75.76.76 0 0 0-.75-.75Z"
    />
    <defs>
      <linearGradient
        id="icon-2cars-sg_svg__a"
        x1={20}
        x2={4.39}
        y1={0}
        y2={19.512}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIcon2CarsSg;
